var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeeloClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "deelo-icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "close",
    d: "M44.39,42.06l-17-17L44.4,8a1.8,1.8,0,0,0,.16-2.51,1.79,1.79,0,0,0-2.51.16L25,22.66l-17-17a1.78,1.78,0,0,0-2.5-.16A1.77,1.77,0,0,0,5.61,8l17,17-17,17a1.8,1.8,0,0,0-.16,2.51A1.79,1.79,0,0,0,8,44.4L25,27.35l17.06,17a1.67,1.67,0,1,0,2.33-2.34Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeeloClose);
export default __webpack_public_path__ + "static/media/deelo_close.0cf804099b9411aa7bd3224f9dbc031c.svg";
export { ForwardRef as ReactComponent };